import { __awaiter } from "tslib";
import { _Site, Site } from "../sites/types.js";
import { spPost } from "../operations.js";
_Site.prototype.joinHubSite = function (siteId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield spPost(this.clone(Site, `joinHubSite('${siteId}')`));
    });
};
_Site.prototype.registerHubSite = function () {
    return __awaiter(this, void 0, void 0, function* () {
        yield spPost(this.clone(Site, "registerHubSite"));
    });
};
_Site.prototype.unRegisterHubSite = function () {
    return __awaiter(this, void 0, void 0, function* () {
        yield spPost(this.clone(Site, "unRegisterHubSite"));
    });
};
//# sourceMappingURL=site.js.map